<!--首页 搜索框、公告等其他显示-->
<template>
  <div class="gray-back" style="padding:.2rem 0 0 0 ;">
    <div style="margin:0 .2rem .2rem 0;text-align: right">
      <van-button v-rblink="{name: 'ClubSearchIndex', }">切换至俱乐部</van-button>
    </div>
    <van-search placeholder="搜索考级中心（点）" v-model="params.keywords" @input="onSearch" style="margin-bottom: .2rem"/>

    <van-cell-group>
      <van-cell class="qcxj-search-title">{{params.keywords ? '搜索"'+params.keywords + '"结果': '为您推荐：全国十佳考级中心'}}</van-cell>
      <van-cell :value="item.danwei + item.kaojitype" class="flex-start" is-link v-for="(item, index) in list"
                v-rblink="{name: 'QcxjDetailUnbind',query: {id: item.id}}">
        <template #icon>
          <img :src="item.pic_url" alt="" style="height: 1.2rem;margin-right: .3rem">
        </template>
      </van-cell>
      <div style="height: 10px"></div>

      <van-cell class="qcxj-search-title">公告</van-cell>
      <van-cell :value="item.title" class="flex-start" is-link v-for="(item, index) in noticeList" v-rblink="{name: 'NewsDetail', query:{id: item.id}}"></van-cell>

      <div style="height: 10px"></div>


    </van-cell-group>

    <div class="savebtn">
      <van-button
          v-if="!row.exame_center.length"
          style="width: 6rem"
          size="large" round >您尚未注册考级中心（点）请点击创建</van-button>
      <van-button
          v-else
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 6rem"
          size="large" round @click="toCenter" >进入我的考级中心（点）</van-button>
    </div>

    <div style="height: 1rem"></div>


    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    <van-action-sheet v-model="centerShow" title="我的考级中心/点">
      <van-cell-group>
        <van-cell :title="item.danwei + item.kaojitype" is-link v-for="(item, index) in row.exame_center" @click="toCheck(item.id)" />
      </van-cell-group>
    </van-action-sheet>
  </div>
</template>
<style scoped>
.qcxj-search-title {
  font-size: 16px;
  font-weight: 700;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);

export default {
  name: 'QcxjSearchIndex',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      centerShow: false,
      saveLoading: false,
      showArea: false,
      submitType: '',
      params: {
        keywords: '',
        pageNo: 1,
        pageSize: 10
      },

      paramsNotice: {
        keywords: '',
        pageNo: 1,
        pageSize: 5
      },
      list: [],
      noticeList: [],
      row: {
        danwei: {},
        exame_center: [],
        club: {}
      },
      formData: {},
    }
  },
  filters: {},
  mounted() {
    document.title = "搜索七彩星级"

    this.fetch();
    this.getList();
    this.getNoticeList();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certClubIndex', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    getList() {
      let that = this;
      that.$api.get('/api/examecenter/centerList', that.params, (res) => {
        that.loading = false;

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      })
    },

    getNoticeList() {
      let that = this;
      that.$api.get('/api/cms/cmsList', that.paramsNotice, (res) => {

        that.noticeList = res.data.list
      })
    },

    toCenter() {
      let that = this,
          centerList =that.row.exame_center

      if(centerList.length === 1) {
        rbLink({
          name: 'QcxjDetailMine',
          query: {
            id: centerList[0].id
          }
        })
      } else if(centerList.length > 1) {
        that.centerShow = true
      } else {
        Toast('暂无绑定的考级中心/点')
      }
    },

    toCheck(id) {
      rbLink({
        name: 'QcxjDetailMine',
        query: {
          id: id
        }
      })
    },

    onSearch() {
      let that =this
      that.loading = [];
      that.params.pageNo = 1
      that.list = []

      if(that.params.keywords) {
        that.params.level = ''
      } else {
        that.params.level = 5
      }
      that.getList()
    },


    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// QcxjSearchIndex.vue?7d5752f0